import React from 'react';
import ReactDOM from 'react-dom/client';
import { AmplifyProvider, Authenticator } from '@aws-amplify/ui-react';

import 'index.scss';
import App from 'app';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AmplifyProvider>
      <Authenticator.Provider>
        <App />
      </Authenticator.Provider>
    </AmplifyProvider>
  </React.StrictMode>
);
